import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl } from '@angular/forms';
import { StorageService } from '@morningstar/shared/base/storage-service';
import { combineLatest, merge } from 'rxjs';
import { debounceTime, filter, map, startWith, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { DashboardBaseComponent } from '../dashboard-base/dashboard-base.component';
import { MailForwardingService } from './mail-forwarding.service';

@Component({
  selector: 'wsg-mail-forwarding',
  templateUrl: './mail-forwarding.component.html',
  styleUrls: ['./mail-forwarding.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MailForwardingComponent extends DashboardBaseComponent  {

  // == CONSTANTS =======================================================

  title = 'Mail Forwarding Addresses';

  // == STATE ===========================================================

  searchText = new FormControl();

  form = this.formBuilder.group({
    location: ''
  });

  // == INTERMEDIATE ====================================================
  
  searchText$ = this.searchText.valueChanges.pipe(
    startWith(''),
    debounceTime(250)
  );

  location$ = this.location.valueChanges.pipe(startWith(''));

  mailForwarding$ = this.location$.pipe(
    switchMap(location => this.mailForwardingService.getByLocation(location))
  );

  mailForwardingList$ = combineLatest([
    this.searchText$,
    this.mailForwarding$
  ]).pipe(
    map(([searchText, results]) => {
      return results.filter(r => {
        const resultText = [
          r.name,
          r.tenantName,
          Object.values(r.address1).join(''),
          !!r.address2 ? Object.values(r.address1).join('') : ''
        ].join('').toLocaleLowerCase();
        
        return resultText.includes(searchText.toLocaleLowerCase());
      });
    })
  );
    
  // == LIFECYCLE =======================================================

  constructor(private mailForwardingService: MailForwardingService,
              private formBuilder: FormBuilder,
              storageService: StorageService) {
    super(storageService);
  };

  // == HELPERS =========================================================

  get location(): AbstractControl {
    return this.form.get('location');
  }
}
